module.exports = __webpack_public_path__ + "img/icb-del-elite-e@3x.8d07ccbb.png";